import { Search } from '@mui/icons-material';
import { Box, FormControl, IconButton, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useI18n } from '../../../../application/language/useI18n';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { PageLoader } from '../../../design/page/PageLoader';
import { IMainLayoutDomainStore } from '../../../layout/main/store/domain/IMainLayoutDomainStore';
import { UserSystemRoleModelPermissionMap } from '../../../../service/systemRole/entity/actions/UserSystemRoleModelPermissionMap';

import { UserRatingTable } from './parts/UserRatingTable';
import { IUserRatingDomain } from './store/IUserRatingDomain';
import { UserRatingDomain } from './store/UserRatingDomain';

export interface IUserRatingPage {
  layoutDomain: IMainLayoutDomainStore;
  includedTeam?: string[];
}
export const UserRating = observer(({ layoutDomain, includedTeam }: IUserRatingPage) => {
  const [userRatingDomain] = useState<IUserRatingDomain>(new UserRatingDomain(layoutDomain));
  const i18n = useI18n();
  const isAdmin = layoutDomain.userHaveAnyAccess([UserSystemRoleModelPermissionMap['global-allow-any']]);

  useEffect(() => {
    userRatingDomain.boot(includedTeam);
  }, [userRatingDomain]);

  return (
    <>
      {userRatingDomain.ui.isLoading.value ? (
        <PageLoader minHeight="100%" />
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, overflow: 'hidden' }}>
          <Box
            sx={{
              display: 'flex',
              gap: '24px',
              justifyContent: 'space-between',
              alignItems: 'flex-end',
              mb: '24px',
              mt: '8px',
            }}
          >
            <TextField
              onChange={(event) => {
                userRatingDomain.ui.searchText.setValue(event.target.value);
                userRatingDomain.fullTextSearch();
              }}
              variant="standard"
              sx={{ flex: '1' }}
              label={i18n.translate('userRating.usersProjectRole')}
              InputProps={{
                endAdornment: (
                  <IconButton>
                    <Search />
                  </IconButton>
                ),
              }}
            />
            <FormControl variant="standard" sx={{ flex: '1' }}>
              <InputLabel>{i18n.translate('userRating.level')}</InputLabel>
              <Select
                defaultValue={'champions'}
                onChange={(event) => {
                  userRatingDomain.ui.filterType.setValue(event.target.value);
                  userRatingDomain.setFilter(userRatingDomain.ui.usersRatingFiltredList.list);
                }}
              >
                <MenuItem value={'champions'}>{i18n.translate('userRating.championsFirst')}</MenuItem>
                <MenuItem value={'newbies'}>{i18n.translate('userRating.newFirst')}</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
            <UserRatingTable
              style={{
                height: '100%',
                overflowY: 'auto',
                overflowX: 'hidden',
              }}
              rows={userRatingDomain.ui.usersRatingFiltredList.list}
              rowAction={isAdmin ? userRatingDomain.onTableRedirect : undefined}
            />
          </Box>
        </Box>
      )}
    </>
  );
});
